import React from 'react';

import { RippleStatus } from '@/components/ui/ripple-status';

export interface AnswerLoadingStatusProps {
  text: string;
  className?: string;
}

export function AnswerLoadingStatus({ text, className }: AnswerLoadingStatusProps) {
  return <RippleStatus text={text} className={className} />;
}
